import { privateApi } from 'services';
import { InstagramAccount } from './types';

const fetchByAdAccountId = async (adAccountId: string): Promise<InstagramAccount[]> =>
    privateApi.get<InstagramAccount[]>(`facebook/graph/ad-accounts/${adAccountId}/instagram-accounts`);

const fetchByPageId = async (pageId: string): Promise<InstagramAccount[]> =>
    privateApi.get<InstagramAccount[]>(`facebook/graph/facebook-pages/${pageId}/instagram-accounts`);

export const InstagramAccountGateway = {
    fetchByAdAccountId,
    fetchByPageId,
};
